// extracted by mini-css-extract-plugin
module.exports = {"textarea":"createpost_textarea__lKjwv","addDiv":"createpost_addDiv__90NQZ","upl":"createpost_upl__2JLRB","uplDiv":"createpost_uplDiv__3QR-j","addons":"createpost_addons__MbGKN"};